import PropTypes from "prop-types";

import { Tooltip } from "@mui/material";

import ArrowCircleUpIcon from "@mui/icons-material/ArrowCircleUp";
import ArrowCircleDownIcon from "@mui/icons-material/ArrowCircleDown";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";

const AlertMarker = ({ alertIcon, alertBody }) => {
  const getIcon = () => {
    switch (alertIcon) {
      case "ArrowCircleUpIcon":
        return <ArrowCircleUpIcon color={"error"} />;
      case "ArrowCircleDownIcon":
        return <ArrowCircleDownIcon color={"error"} />;
      case "TrendingUpIcon":
        return <TrendingUpIcon color={"error"} />;
      case "ErrorOutlineIcon":
        return <ErrorOutlineIcon color={"error"} />;

      default:
        return null;
    }
  };

  return (
    <div style={{ display: "flex" }}>
      <Tooltip title={alertBody}>{getIcon()}</Tooltip>
    </div>
  );
};

AlertMarker.propTypes = {
  alertIcon: PropTypes.string,
  alertBody: PropTypes.string,
};

export default AlertMarker;
